(function () {
    myonce('filter-page', function () {
        const $filterPage = document.querySelector('.filter-page');
        const $filterSections = [].slice.call(document.querySelectorAll('.filter-section'));
        const $filterGroups = [].slice.call(document.querySelectorAll('.filter-group'));
        const $filterAccordions = $filterGroups.filter(group => !!group.classList.contains('has-accordion')).concat($filterSections.filter(group => !group.classList.contains('is-primary')));
        const $filters = [].slice.call(document.querySelectorAll('[data-filter]'));
        const $forms = [].slice.call(document.querySelectorAll('form.filter-form'));
        const $inputs = [].slice.call(document.querySelectorAll('.filter input:not([type="submit"]), .filter select'));
        const $cta = document.querySelector('.cta-send-filter');
        const $ctaMobileForm = document.querySelector('#cta-submit-form-filter');
        const $ctaOtherFilter = document.querySelector('#cta-submit-form-filter-next-page');
        const $bookmarksContainer = [].slice.call(document.querySelectorAll('.container-bookmarks'));
        const $loader = document.querySelector('.loader-generic');
        let renderElements = [];
        let laterElements = [];
        let groupBy = null;
        let bookmarks = [];
        let lastPayload = preparePayload();
        let currPage = 0;
        let freeSearch;
        let brandPageId;
        let _isFetching = false;
        function checkQueryParams() {
            const uri = sanitizeUri(window.location.href);
            const searchParams = window.location.search;
            if (uri && searchParams) {
                const urlParams = new URLSearchParams(searchParams);
                if (urlParams.has("field_price")) {
                    const value = urlParams.get("field_price").split(',');
                    const min = value[0];
                    const max = value[1];
                    const $sliderContainer = $filterPage.querySelector('#field_price');
                    if ($sliderContainer) {
                        const $slider = $sliderContainer.querySelector('.range-slider--bar');
                        $slider.noUiSlider.set([min, max]);
                    }
                }
                if (urlParams.has("field_type")) {
                    const params = urlParams.get("field_type");
                    const values = params.split(',');
                    values.forEach(val => {
                        if (val) {
                            const inputs = [].slice.call(document.querySelectorAll('[name="field_type"]'));
                            inputs.forEach(input => {
                                if (input.value.includes(val)) {
                                    if (!input.checked) {
                                        input.checked = true;
                                        trigger(input, 'change');
                                    }
                                }
                            });
                        }
                    });
                }
                if (urlParams.has("search")) {
                    const $index = document.querySelector('[data-filter-id="index"] input');
                    const $searchEl = document.querySelector('#field_search');
                    let payload = {
                        query: urlParams.get("search"),
                        page: currPage,
                        date: new Date().getTime(),
                        index: $index && $index.value,
                        sort: groupBy === '' || !groupBy ? null : 'field_price',
                        order: groupBy,
                        offers: false,
                        filters: []
                    };
                    payload = checkFreeSearchPromo(payload);
                    payload.query = titleCase(payload.query);
                    $searchEl.setAttribute('data-title', 'ricerca');
                    if (payload.query) {
                        $searchEl.setAttribute('data-name', payload.query);
                        $searchEl.value = payload.query;
                        addBookmark($searchEl);
                    }
                    lastPayload = payload;
                    freeSearch = payload.query;
                }
                if (urlParams.has("field_price") || urlParams.has("field_type")) {
                    if ($forms && $forms.length > 0 && !urlParams.has("search")) {
                        const $cta = document.querySelector('.cta-send-filter');
                        if ($cta) {
                            $filterPage.classList.remove('active');
                        }
                    }
                }
            }
        }
        function brandPage() {
            const $title = document.querySelector('.title-area');
            if ($title && !!$title.getAttribute('data-brand')) {
                brandPageId = +$title.getAttribute('data-brand');
                const $select = $filterPage.querySelector('#field_brand');
                if ($select) {
                    $select.parentNode.parentNode.classList.add('is-brand-page');
                    const $options = [].slice.call($select.querySelectorAll('option'));
                    for (const $option of $options) {
                        if (+$option.value === brandPageId) {
                            const option = $filterPage.querySelector('[data-value=' + CSS.escape(brandPageId) + ']');
                            onOptionClick(option, $select.querySelector('select'), true);
                            return;
                        }
                    }
                }
            }
        }
        function collectionHas(a, b) {
            for (var i = 0, len = a.length; i < len; i++) {
                if (a[i] == b)
                    return true;
            }
            return false;
        }
        function findParentBySelector(elm, selector) {
            var all = document.querySelectorAll(selector);
            var cur = elm.parentNode;
            while (cur && !collectionHas(all, cur)) {
                cur = cur.parentNode;
            }
            return cur;
        }
        function bind() {
            if ($filterPage) {
                const iconClose = $filterPage.querySelector('.icon-close-modal');
                const ctaMobileFilter = $filterPage.parentNode.querySelector('.cta-fixed-filter-mobile');
                if (iconClose) {
                    iconClose.addEventListener('click', (e) => {
                        $filterPage.classList.toggle('active');
                    });
                }
                if (ctaMobileFilter) {
                    ctaMobileFilter.addEventListener('click', (e) => {
                        $filterPage.classList.toggle('active');
                    });
                }
            }
            $filterAccordions.forEach($accordion => {
                const $toggle = $accordion.querySelector('.title');
                $toggle.removeEventListener('click', () => {
                });
                $toggle.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    $accordion.classList.toggle('active');
                });
                const $toggleIcon = $accordion.querySelector('.icon');
                $toggleIcon.removeEventListener('click', () => {
                });
                $toggleIcon.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    $accordion.classList.toggle('active');
                });
            });
            $inputs.forEach($input => {
                $input.removeEventListener('change', () => {
                });
                $input.removeEventListener('click', () => {
                });
                $input.addEventListener('click', (e) => {
                    if (e.currentTarget.type === 'radio' && e.currentTarget.checked) {
                        if (e.currentTarget.classList.contains('checked')) {
                            e.currentTarget.checked = false;
                            e.currentTarget.classList.remove('checked');
                            deleteBookmark({
                                id: e.currentTarget.getAttribute('id'),
                                name: e.currentTarget.getAttribute('data-name')
                            });
                            trigger(e.currentTarget, 'change');
                        }
                        else {
                            e.currentTarget.classList.add('checked');
                        }
                    }
                });
                $input.addEventListener('change', (e) => {
                    const filter = findParentBySelector($input, '.filter');
                    handleInteraction(filter);
                    if (!!e.currentTarget.getAttribute('data-name')) {
                        if (e.currentTarget.checked) {
                            if (e.currentTarget.type === 'radio') {
                                checkRadioGroupLabel(e.currentTarget.getAttribute('name'));
                            }
                            addBookmark(e.currentTarget);
                        }
                        else if (e.currentTarget.type !== 'select-one' && !e.currentTarget.checked) {
                            deleteBookmark({
                                id: e.currentTarget.getAttribute('id'),
                                name: e.currentTarget.getAttribute('data-name')
                            });
                        }
                        else if (e.currentTarget.type === 'select-one' && !!e.currentTarget.value) {
                            addBookmark(e.currentTarget);
                        }
                    }
                });
            });
            $forms.forEach(($form) => {
                handleSubmit($form);
            });
            if ($ctaMobileForm) {
                $ctaMobileForm.removeEventListener('click', () => {
                });
                $ctaMobileForm.addEventListener('click', (e) => {
                    if ($forms && $forms.length > 0) {
                        if ($cta) {
                            $cta.click();
                            $filterPage.classList.toggle('active');
                        }
                    }
                });
            }
            $ctaOtherFilter.removeEventListener('click', () => {
            });
            $ctaOtherFilter.addEventListener('click', () => {
                lastPayload.page = currPage;
                query(lastPayload);
            });
        }
        function handleInteraction($f) {
            const $inputs = [].slice.call($f.querySelectorAll('input:not([type="checkbox"]), input:not([type="radio"]), select'));
            const inputs = $inputs.reduce((a, $c) => {
                $c.value && $c.value !== '#' && a++;
                return a;
            }, 0);
            const $checkboxes = [].slice.call($f.querySelectorAll('input[type="checkbox"], input[type="checkbox"]'));
            const checkboxes = $checkboxes.reduce((a, $c) => {
                $c.checked && a++;
                return a;
            }, 0);
            $f.setAttribute('data-dirty', Number(inputs + checkboxes > 0));
        }
        function removeToggleElement(obj) {
            const $el = $filterPage.querySelector('#' + obj.id);
            const $elCustom = $filterPage.querySelector('.' + obj.id);
            if ($el && $elCustom) {
                if ($el.checked) {
                    $el.checked = false;
                    trigger($el, 'change');
                }
                else if ($el.type === 'select-one') {
                    $el.value = null;
                    const $selectSelected = $elCustom.parentNode.querySelector('.select-selected');
                    $selectSelected.setAttribute('data-name', '');
                    $selectSelected.innerHTML = $elCustom.querySelectorAll('option')[0].innerHTML;
                    if ($elCustom.getAttribute('id') === 'select-field_brand') {
                        resetOptionForModel();
                    }
                    else {
                        let event = document.createEvent("Event");
                        event.initEvent("change", false, true);
                        $el.dispatchEvent(event);
                        trigger($el, 'change');
                    }
                }
                else if ($filterPage.querySelector('#' + obj.id).classList.contains('range-slider')) {
                    const $rangeSlider = $filterPage.querySelector('#' + obj.id);
                    const slider = $rangeSlider.querySelector('.range-slider--bar');
                    const min = +slider.getAttribute('data-min') || 0; 
                    const max = +slider.getAttribute('data-max'); 
                    const $inputMin = slider.parentNode.querySelector('.range-slider--values--start-input');
                    const $inputMax = slider.parentNode.querySelector('.range-slider--values--end-input');
                    const $sliderMin = slider.parentNode.querySelector('.range-slider--values--start--value');
                    const $sliderMax = slider.parentNode.querySelector('.range-slider--values--end--value');
                    $sliderMin.innerHTML = min;
                    $sliderMax.innerHTML = max;
                    $sliderMax.setAttribute('data-label-value', max);
                    $inputMin.value = +min;
                    $inputMax.value = +max;
                    slider.noUiSlider.set([+min, +max]);
                }
            }
        }
        function renderBookmark() {
            $bookmarksContainer.forEach(container => {
                const $oldBookmarks = [].slice.call(container.querySelectorAll('.bookmark'));
                $oldBookmarks.length > 0 && $oldBookmarks.forEach(old => old.parentNode.removeChild(old));
                if (bookmarks.length > 0) {
                    bookmarks.forEach(bookmark => {
                        const $newBookmark = document.createElement('div');
                        $newBookmark.classList.add('bookmark');
                        $newBookmark.setAttribute('data-id', bookmark.id);
                        if (bookmark.name === 'field_car') {
                            $newBookmark.innerHTML = '<div class="bookmark--title"></div> <div class="bookmark--content"> Offerta<label for="' + bookmark.id + '" class="icon rcs-icon-close"></label></div>';
                        }
                        else if (!!bookmark.name) {
                            $newBookmark.innerHTML = '<div class="bookmark--title">' + bookmark.title + '</div> <div class="bookmark--content">' + bookmark.name + '<label for="' + bookmark.id + '" class="icon rcs-icon-close"></label></div>';
                        }
                        else {
                            const $rangeSlider = $filterPage.querySelector('#' + bookmark.id);
                            const min = $rangeSlider.querySelector('.range-slider--values--start').textContent.trim();
                            const $inputMax = $rangeSlider.querySelector('.range-slider--values--end');
                            const maxValue = $inputMax.querySelector('[data-label-value]').getAttribute('data-label-value');
                            const prefix = $inputMax.querySelector('.range-slider--values--end--value--prefix').textContent.trim();
                            const max = isNaN(parseInt(maxValue)) ? maxValue : `${maxValue}${prefix}`;
                            $newBookmark.innerHTML = '<div class="bookmark--title">' + bookmark.title + '</div> <div>' + 'da ' + min + ' a ' + max + '<label for="' + bookmark.id + '" class="icon rcs-icon-close"></label> <div>';
                        }
                        container.appendChild($newBookmark);
                        $newBookmark.querySelector('.icon').addEventListener('click', e => deleteBookmark(bookmark));
                    });
                    container.classList.add('active');
                }
                else {
                    $bookmarksContainer.forEach(container => container.classList.remove('active'));
                }
            });
        }
        function removeExistentTile() {
            if ($filterPage.parentNode.querySelector('.filters-result-container').children && $filterPage.parentNode.querySelector('.filters-result-container').children.length > 0) {
                [].slice.call($filterPage.parentNode.querySelector('.filters-result-container').children).forEach((child, index) => {
                    child.parentNode.removeChild(child);
                });
            }
            const $cardList = document.querySelector('.card-list');
            if ($cardList && !$cardList.classList.contains('filters-result-container')) {
                $cardList.parentNode.removeChild($cardList);
            }
        }
        function noResult(status) {
            const $noResDiv = document.createElement('div');
            $noResDiv.classList.add('text--center');
            $noResDiv.classList.add('text--purple');
            $noResDiv.classList.add('text--2x');
            $noResDiv.classList.add('m-auto');
            $noResDiv.classList.add('py-50');
            const text = status ? document.querySelector('#no-result-filter-page').innerHTML : `C'è stato un errore. Ci scusiamo per il disagio, riprova più tardi.`;
            $noResDiv.innerHTML = text;
            $filterPage.parentNode.querySelector('.filters-result-container').appendChild($noResDiv);
        }
        function setResultsNumber(num) {
            const $containerInfoFilter = document.querySelector('.info-results');
            if ($containerInfoFilter) {
                $containerInfoFilter.querySelector('span').innerText = num;
                $containerInfoFilter.classList.remove('hidden');
            }
        }
        function generateOffer(res) {
            $filterPage.parentNode.querySelector('.filters-result-container').classList.add('card-list');
            res.forEach(item => {
                const $cloneCard = $filterPage.querySelector('.card-to-clone').cloneNode(true);
                const $link = $cloneCard.querySelector('a');
                item.url ? $link.setAttribute('href', item.url) : $link.setAttribute('href', '#');
                const $image = $cloneCard.querySelector('.card--promo--image-container');
                $image && item.image ? $image.style.cssText = 'background-image: url(' + item.image + ')' : null;
                const $title = $cloneCard.querySelector('.card--promo--content--title');
                $title.innerHTML = item.title;
                const $descr = $cloneCard.querySelector('.content');
                $descr.innerHTML = item.description;
                if (item.editorialBadge) {
                    const $editorialBadge = $cloneCard.querySelector('.card--badge--most-visited');
                    $editorialBadge.innerHTML = item.editorialBadge;
                    $editorialBadge.classList.remove('hidden');
                }
                $filterPage.parentNode.querySelector('.filters-result-container').appendChild($cloneCard);
                $cloneCard.classList.remove('hidden');
            });
        }
        function generateCar(res) {
            $filterPage.parentNode.querySelector('.filters-result-container').classList.add('card-list');
            res.forEach(item => {
                if (item.bundle === 'car') {
                    const $cloneCard = $filterPage.querySelector('.card-to-clone').cloneNode(true);
                    const $link = $cloneCard.querySelector('a');
                    item.url ? $link.setAttribute('href', item.url) : $link.setAttribute('href', '#');
                    const $image = $cloneCard.querySelector('.card--offer--image-container');
                    $image && item.image ? $image.style.cssText = 'background-image: url(' + item.image + ')' : null;
                    const $brand = $cloneCard.querySelector('.card--offer--content--brand');
                    $brand.innerHTML = item.brandName;
                    const $model = $cloneCard.querySelector('.card--offer--content--model');
                    $model.innerHTML = item.title;
                    const $price = $cloneCard.querySelector('.full-price');
                    const formatter = new Intl.NumberFormat('it-IT', {
                        style: 'currency',
                        currency: 'EUR',
                        minimumFractionDigits: 0
                    });
                    $price.innerHTML = formatter.format(+item.price);
                    const $cta = $cloneCard.querySelector('.cta-add-to-compare-card');
                    $cta.setAttribute('data-model-name', item.title);
                    $cta.setAttribute('data-variation-id', item.variationId);
                    $cta.setAttribute('data-variation-full-name', item.variationFullName);
                    $cta.setAttribute('data-variation-name', item.variationName);
                    $cta.setAttribute('data-variation-brand', item.brandName);
                    const offers = window.offers_data || [];
                    const id = item.id || '';
                    if (offers.includes(id.toString())) {
                        const $offer = $cloneCard.querySelector('.card--badge--last-news');
                        $offer.classList.remove('hidden');
                        $price.classList.add('strikethrough');
                    }
                    if (item.editorialBadge) {
                        const $editorialBadge = $cloneCard.querySelector('.card--badge--most-visited');
                        $editorialBadge.innerHTML = item.editorialBadge;
                        $editorialBadge.classList.remove('hidden');
                    }
                    $filterPage.parentNode.querySelector('.filters-result-container').appendChild($cloneCard);
                    $cloneCard.classList.remove('hidden');
                }
            });
            addToCompareCard();
        }
        function onOptionClick(option, select, blocked) {
            select.setAttribute('data-name', option.innerText);
            select.value = option.getAttribute('data-value') || null;
            let event = document.createEvent("Event");
            event.initEvent("change", false, true);
            select.dispatchEvent(event);
            select.parentNode.querySelector('.select-items').classList.add('select-hide');
            trigger(select, 'change');
            if (option.parentNode.parentNode.getAttribute('id') === 'field_brand') {
                const $modelSelect = $filterPage.querySelector('#field_model');
                if ($modelSelect) {
                    deleteBookmark({
                        id: $modelSelect.querySelector('select').getAttribute('id'),
                        name: $modelSelect.querySelector('select').getAttribute('data-name'),
                        blocked: blocked
                    });
                    getModel(+select.value);
                }
            }
        }
        function selectGroupBy() {
            const $selectGroupBy = document.querySelector('.select-group-by');
            if ($selectGroupBy) {
                const $options = [].slice.call($selectGroupBy.querySelector('.select-items').querySelectorAll('div'));
                $options.forEach(item => {
                    item.addEventListener('click', (e) => {
                        groupBy = e.currentTarget.getAttribute('data-value');
                        $cta.click();
                    });
                });
            }
        }
        function selectChange() {
            if ($filterSections && $filterSections.length > 0) {
                $filterSections.forEach(section => {
                    const $selects = section.querySelectorAll('.custom-select');
                    if ($selects && $selects.length > 0) {
                        $selects.forEach(select => {
                            const $select = select.querySelector('select');
                            if ($select) {
                                const $selected = select.querySelector('.select-items');
                                if ($selected) {
                                    const $items = $selected.querySelectorAll('div');
                                    if ($items && $items.length > 0) {
                                        $items.forEach(item => {
                                            item.removeEventListener('click', () => {
                                            });
                                            item.addEventListener('click', e => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                onOptionClick(e.currentTarget, $select);
                                            });
                                        });
                                    }
                                }
                            }
                        });
                    }
                });
            }
        }
        function rangeSlider() {
            const groups = document.querySelectorAll('.filter-form');
            let indexRangeSlider = 0;
            groups.forEach(group => {
                const rangeSliders = group.querySelectorAll('.range-slider');
                if (rangeSliders && rangeSliders.length > 0) {
                    rangeSliders.forEach(sliderContainer => {
                        const slider = sliderContainer.querySelector('.range-slider--bar');
                        const minRange = +slider.getAttribute('data-min') || 0; 
                        const maxRange = +slider.getAttribute('data-max'); 
                        const step = +slider.getAttribute('data-step') || 1; 
                        const $inputMin = slider.parentNode.querySelector('.range-slider--values--start-input');
                        const $inputMax = slider.parentNode.querySelector('.range-slider--values--end-input');
                        const $sliderMin = slider.parentNode.querySelector('.range-slider--values--start--value');
                        const $sliderMax = slider.parentNode.querySelector('.range-slider--values--end--value');
                        if ($inputMin && $inputMax && $sliderMin && $sliderMax && maxRange) {
                            sliderContainer.classList.add('index-' + indexRangeSlider);
                            indexRangeSlider++;
                            const $slider = noUiSlider.create(slider, {
                                start: [minRange, maxRange],
                                step: step,
                                connect: true,
                                format: wNumb({
                                    decimals: 0,
                                    thousand: '.'
                                }),
                                range: {
                                    'min': minRange,
                                    'max': maxRange
                                }
                            });
                            $slider.on('set', function ([min, max]) {
                                if (min.toString().replace(/[^\d,]/gi, '') === minRange.toString() && max.toString().replace(/[^\d,]/gi, '') === maxRange.toString()) {
                                    const objBookmark = {
                                        id: slider.parentNode.getAttribute('id'),
                                        title: slider.parentNode.getAttribute('data-title'),
                                        name: slider.parentNode.getAttribute('data-name')
                                    };
                                    if (bookmarks.filter(item => item.id === slider.parentNode.getAttribute('id')).length > 0) {
                                        deleteBookmark(objBookmark);
                                    }
                                }
                                else {
                                    addBookmark(slider.parentNode);
                                }
                                if (+max.replace(/[.]/gi, '') === maxRange)
                                    $inputMax.value = 1000000000000;
                                trigger($inputMin, 'change');
                                trigger($inputMax, 'change');
                            });
                            $slider.on('update', function ([min, max]) {
                                $sliderMin.innerHTML = min;
                                $sliderMax.innerHTML = +max.replace(/[.]/gi, '') === maxRange ? 'Max' : max;
                                $sliderMax.setAttribute('data-label-value', +max.replace(/[.]/gi, '') === maxRange ? 'Max' : max);
                                $inputMin.value = +min.replace(/[^\d,]/gi, '');
                                $inputMax.value = +max.replace(/[^\d,]/gi, '');
                            });
                        }
                    });
                }
            });
        }
        function checkModelSelect() {
            const $modelSelect = $filterPage.querySelector('#field_model');
            if ($modelSelect) {
                $modelSelect.classList.add('disabled');
            }
        }
        function extendedUI() {
            rangeSlider();
            selectChange();
            checkModelSelect();
        }
        function titleCase(str) {
            return str && str
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        }
        function checkFreeSearchPromo(payload) {
            const promo = /^offer(t.?)?|\soffer(t.?)?|^promo(zion.?)?|\spromo(zion.?)?/gi;
            const query = payload.query;
            if (promo.test(query)) {
                payload.query = query.replace(promo, '').trim();
                payload.offers = true;
                const $promoEl = document.querySelector('#switch-field_car');
                $promoEl.checked = true;
                $promoEl.parentNode.parentNode.setAttribute('data-dirty', 1);
            }
            return payload;
        }
        function checkRadioGroupLabel(nameGroup) {
            const $radios = [].slice.call(document.querySelectorAll('[name=' + nameGroup + ']'));
            if ($radios && $radios.length > 0) {
                $radios.forEach(radio => {
                    if (!radio.checked) {
                        deleteBookmark({
                            id: radio.getAttribute('id'),
                            name: radio.getAttribute('data-name')
                        });
                    }
                });
            }
        }
        function checkValueRangeSlider($model) {
            const id = $model.getAttribute('data-id');
            const rangeSlider = document.querySelector('#' + id);
            let isStartValues = false;
            if (rangeSlider) {
                const $inputMin = rangeSlider.querySelector('.range-slider--values--start-input').value;
                const $inputMax = rangeSlider.querySelector('.range-slider--values--end-input').value;
                const slider = rangeSlider.querySelector('.range-slider--bar');
                const minRange = +slider.getAttribute('data-min') || 0; 
                const maxRange = +slider.getAttribute('data-max'); 
                +$inputMin === minRange && +$inputMax === maxRange ? isStartValues = true : isStartValues = false;
            }
            else {
                isStartValues = false;
            }
            return isStartValues;
        }
        function deleteBookmark(obj) {
            if (obj.id === 'field_search') {
                freeSearch = null;
            }
            if (obj.blocked) {
                bookmarks.splice(0);
            }
            else {
                if (bookmarks.indexOf(bookmarks.find(book => book.id === obj.id)) > -1) {
                    bookmarks.splice(bookmarks.indexOf(bookmarks.find(book => book.id === obj.id)), 1);
                }
            }
            renderBookmark();
            removeToggleElement(obj);
            const $modelSelect = $filterPage.querySelector('#field_model');
            if ($modelSelect && obj.id === 'select-field_brand') {
                deleteBookmark({
                    id: $modelSelect.querySelector('select').getAttribute('id'),
                    name: $modelSelect.querySelector('select').getAttribute('data-name'),
                });
            }
        }
        function addBookmark(el) {
            const objBookmark = {
                id: el.getAttribute('id'),
                title: el.getAttribute('data-title'),
                name: el.getAttribute('data-name'),
                value: el.value
            };
            if ((el.type && el.checked) || (el.type === 'select-one' && el.value)) {
                if (bookmarks.length > 0) {
                    const sameBookMark = bookmarks.find(bookmark => bookmark.id === objBookmark.id);
                    if (sameBookMark) {
                        sameBookMark.name === objBookmark.name && el.type !== 'select-one' ? deleteBookmark(objBookmark) : sameBookMark.name = objBookmark.name;
                    }
                    else {
                        bookmarks.unshift(objBookmark);
                    }
                }
                else {
                    bookmarks.unshift(objBookmark);
                }
            }
            else if (el.classList.contains('range-slider')) {
                const sameBookMark = bookmarks.find(bookmark => bookmark.id === objBookmark.id);
                if (!sameBookMark) {
                    bookmarks.unshift(objBookmark);
                }
            }
            else if (el.getAttribute('id') === 'field_search') {
                bookmarks.unshift(objBookmark);
            }
            else {
                deleteBookmark(objBookmark);
            }
            renderBookmark();
        }
        function resetOptionForModel() {
            const $modelSelect = $filterPage.querySelector('#field_model');
            const $el = $modelSelect.querySelector('select');
            if ($modelSelect && $el) {
                $el.value = null;
                const $selectSelected = $modelSelect.parentNode.querySelector('.select-selected');
                $selectSelected.setAttribute('data-name', '');
                $selectSelected.setAttribute('data-value', '#');
                $el.setAttribute('data-name', '');
                $selectSelected.innerHTML = $modelSelect.querySelectorAll('option')[0].innerHTML;
                $el.querySelectorAll('option').forEach((option, index) => {
                    if (index !== 0) {
                        option.parentNode.removeChild(option);
                    }
                });
                $modelSelect.querySelector('.select-items').querySelectorAll('div').forEach(div => div.parentNode.removeChild(div));
                let event = document.createEvent("Event");
                event.initEvent("change", false, true);
                $el.dispatchEvent(event);
                trigger($el, 'change');
            }
        }
        function createOptionForModel(response) {
            const $modelSelect = $filterPage.querySelector('#field_model');
            if ($modelSelect.querySelector('select')) {
                response.forEach(function (model) {
                    let option = document.createElement('option');
                    option.setAttribute('value', model.id);
                    option.innerText = model.name;
                    let div = document.createElement('div');
                    div.setAttribute('data-value', model.id);
                    div.innerText = model.name;
                    $modelSelect.querySelector('select').appendChild(option);
                    $modelSelect.querySelector('.select-items').appendChild(div);
                    div.removeEventListener('click', () => {
                    });
                    div.addEventListener('click', e => {
                        e.preventDefault();
                        e.stopPropagation();
                        const $select = $modelSelect.querySelector('select');
                        $select.setAttribute('data-name', e.currentTarget.innerText);
                        $select.value = e.currentTarget.getAttribute('data-value') || null;
                        let event = document.createEvent("Event");
                        event.initEvent("change", false, true);
                        $select.dispatchEvent(event);
                        $select.parentNode.querySelector('.select-items').classList.add('select-hide');
                        trigger($select, 'change');
                    });
                });
                $modelSelect.classList.remove('disabled');
                onClickItem();
            }
        }
        function getModel(id) {
            Fetch({
                uri: '/api/content/car/' + id,
                method: 'GET'
            }).then((response) => {
                resetOptionForModel();
                createOptionForModel(response);
            }).finally(() => {
                _isFetching = false;
            });
        }
        function handleSubmit($f) {
            $f.removeEventListener('submit', () => {
            });
            $f.addEventListener('submit', (e) => {
                e.preventDefault();
                setPage(0);
                let payload = preparePayload();
                $filters.forEach(($filter) => {
                    const id = $filter.getAttribute('data-filter-id');
                    const dirty = $filter.getAttribute('data-dirty') === "1";
                    let type = $filter.getAttribute('data-filter-type');
                    if (dirty && id && type) {
                        type = getQueryType(type);
                        const $model = [].slice.call($filter.querySelectorAll('input, select'));
                        const value = getValue($model, type);
                        if (Array.isArray(value) && value.length || !Array.isArray(value) && value) {
                            if (id !== 'field_car') {
                                payload.filters.push({
                                    id,
                                    type,
                                    value
                                });
                            }
                            else {
                                payload.offers = value;
                            }
                        }
                    }
                });
                query(payload);
            });
        }
        function calcRenderEl(elements) {
            if (elements.length === 0 && laterElements.length) {
                renderElements = laterElements;
                return true;
            }
            if (laterElements && laterElements.length) {
                elements = laterElements.concat(elements);
                laterElements = [];
            }
            if (elements.length >= 12) {
                const offset = elements.length - (elements.length % 12);
                renderElements = elements.slice(0, offset);
                laterElements = elements.slice(offset);
                return true;
            }
            else {
                laterElements = elements;
                $ctaOtherFilter.click();
                return false;
            }
        }
        function setOfferFilter(data) {
            if (offers_data) {
                const filter = {
                    id: 'field_car',
                    type: 'IN',
                    value: offers_data
                };
                data.filters.push(filter);
            }
            return data;
        }
        function query(data) {
            const type = $filterPage.getAttribute('data-action');
            const uri = '/api/search?_format=json';
            if (data.offers) {
                data = setOfferFilter(data);
            }
            data.cacheKey = type.toLowerCase().slice(0, 1);
            $ctaOtherFilter.classList.add('hidden');
            $loader.classList.add('active');
            Fetch({
                uri: uri,
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                data,
            }).then((response) => {
                lastPayload = data;
                if (currPage === 0) {
                    removeExistentTile();
                    laterElements = null;
                }
                nextPage();
                if (response && response.status && currPage <= response.totalPages && calcRenderEl(response.results)) {
                    if (type.toLowerCase() === 'offers') {
                        generateOffer(renderElements);
                    }
                    else {
                        generateCar(renderElements);
                    }
                    setResultsNumber(response.count);
                    if (response && response.count <= response.paging) {
                        $ctaOtherFilter.classList.add('hidden');
                    }
                    else {
                        $ctaOtherFilter.classList.remove('hidden');
                    }
                }
                else {
                    if (laterElements && laterElements.length && currPage > 0) {
                        if (type.toLowerCase() === 'offers') {
                            generateOffer(laterElements);
                        }
                        else {
                            generateCar(laterElements);
                        }
                        laterElements = [];
                        setResultsNumber(response.count);
                        $ctaOtherFilter.classList.add('hidden');
                    }
                    else if (!response.count) {
                        noResult(response.status);
                        setResultsNumber(0);
                    }
                }
            }).finally(() => {
                $loader.classList.remove('active');
            });
        }
        function getQueryType(type) {
            let ret = '';
            switch (type) {
                case 'switch':
                    ret = 'EXACT';
                    break;
                case 'rangeSlider':
                    ret = 'BETWEEN';
                    break;
                case 'select':
                case 'buttonSet':
                    ret = 'IN';
                    break;
            }
            return ret;
        }
        function getValue($model, type) {
            const values = $model.reduce((acc, $m) => {
                const val = $m.value.split(';').filter(v => v !== '').map((v) => {
                    return isNaN(Number(v)) ? v : Number(v);
                });
                switch ($m.type) {
                    case 'checkbox':
                        if ($m.value !== "on" && $m.checked) {
                            acc = acc.concat(val);
                        }
                        else if ($m.checked) {
                            acc.push($m.checked);
                        }
                        break;
                    case 'radio':
                        if ($m.checked) {
                            acc = acc.concat(val);
                        }
                        break;
                    default:
                        if (!checkValueRangeSlider($m)) {
                            acc = acc.concat(val);
                        }
                }
                return acc;
            }, []);
            return type === 'EXACT' ? values.pop() : values;
        }
        function preparePayload() {
            const $index = document.querySelector('[data-filter-id="index"] input');
            return {
                query: freeSearch ? freeSearch : '*',
                page: currPage,
                date: new Date().getTime(),
                index: $index && $index.value,
                sort: groupBy === '' || groupBy === null ? null : 'field_price',
                order: groupBy,
                offers: false,
                filters: [],
                cacheKey: '',
            };
        }
        function setPage(val) {
            currPage = val;
        }
        function nextPage() {
            currPage++;
        }
        function prevPage() {
            currPage--;
        }
        function init() {
            if ($filterPage) {
                bind();
                extendedUI();
                brandPage();
                checkQueryParams();
                selectGroupBy();
                $cta.click();
            }
        }
        init();
    });
}());
